// BIG4 Holiday Parks booking strategy.
//
// A site's reserveUrl is the category's own page on big4.com.au
// (/caravan-parks/{state}/{region}/{park}/accommodation/{category}). The page
// takes the stay and the party in its query string (`start`, `end` as
// YYYY-MM-DD, `adults`) and opens with them filled in and the price quoted,
// one "Book this stay" away from the cart. A stay that breaks the park's
// rules renders the park's own message ("Minimum stay 5 nights, please adjust
// your dates"). Campsites then ask for the rig's type and size, which the
// camper enters on the page.

import { format } from "date-fns";
import { resolveCheckout } from "./_context.js";

const isoDate = (date) => format(date, "yyyy-MM-dd");

// Two adults, the party the scanner quotes with when a request names none.
const DEFAULT_ADULTS = 2;

export default {
  buildBookingUrl(ctx) {
    const { site, arrivalDate, partySize } = ctx;
    const url = new URL(site.reserveUrl);
    url.search = "";
    url.searchParams.set("start", isoDate(arrivalDate));
    url.searchParams.set("end", isoDate(resolveCheckout(ctx)));
    url.searchParams.set("adults", String(partySize ?? DEFAULT_ADULTS));
    return url.toString();
  },

  // The park's page lists every category it sells; the reserveUrl is one
  // category's page.
  buildPreviewUrl(site) {
    const url = new URL(site.reserveUrl);
    url.search = "";
    url.pathname = url.pathname.replace(/\/accommodation\/[^/]+\/?$/, "");
    return url.toString();
  },

  describeBookingInputs() {
    return {
      inputs: {
        arrivalDate: {
          status: "required",
          notes: "Encoded as ?start=<yyyy-MM-dd>.",
        },
        departureDate: {
          status: "required",
          notes:
            "Encoded as &end=<yyyy-MM-dd>; resolved from arrival + minStayLength when not supplied.",
        },
        ref: {
          status: "ignored",
          notes: "site.reserveUrl already is the category's page.",
        },
        partySize: {
          status: "defaulted",
          defaultValue: DEFAULT_ADULTS,
          notes:
            "Encoded as &adults=<N>; two adults when the request names none.",
        },
      },
    };
  },
};
